<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Add Participant Agreement</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="loadingDocumentTemplates">
    <h3 class="text-muted">Loading...</h3>
  </div>

  <div class="modal-body" *ngIf="!loadingDocumentTemplates">

    <div class="mb-2">
      <label for="selectedDocumentTemplate">Document Template</label>
      <select class="custom-select"
              id="selectedDocumentTemplate" name="selectedDocumentTemplate"
              [(ngModel)]="selectedDocumentTemplate"
              *ngIf="documentTemplates.length > 0">
        <option *ngFor="let dt of documentTemplates"
                [ngValue]="dt">
          {{ dt.name }}
        </option>
      </select>
      <select class="custom-select disabled"
              [(ngModel)]="selectedDocumentTemplate"
              *ngIf="documentTemplates.length === 0"
              disabled>
        <option>No document templates configured</option>
      </select>
    </div>

    <div>
      <label>Locations</label>

      <div class="form-check ml-3" *ngFor="let location of locations">
        <input class="form-check-input" type="checkbox"
               [id]="'location-' + location.id.toString()"
               [checked]="selectedLocationIds.includes(location.id)"
               (change)="toggleLocationId(location.id)">
        <label class="form-check-label"
               [for]="'location-' + location.id.toString()">
          {{ location.name }}
        </label>
      </div>
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Go Back
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!loadingDocumentTemplates"
            [disabled]="selectedDocumentTemplate === null"
            [class.disabled]="selectedDocumentTemplate === null"
            (click)="handleSubmit()">
      Submit
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingDocumentTemplates">
      Loading...
    </button>
  </div>

</ng-container>
